export default "__VITE_ASSET__2b99f07d__"